import { classNames, selectors } from './lib';
import { toMinutes } from './utils';

export const initExternalControl = (player) => {
	const playerEpisodeID = player.getAttribute('data-episode-id');
	const externalControl = document.querySelector(`${selectors.externalControl}[data-episode-id="${playerEpisodeID}"]`);
	const stickyPlayer = document.querySelector(`${selectors.stickyPlayer}[data-episode-id="${playerEpisodeID}"]`);

	if (!externalControl || !stickyPlayer) {
		return;
	}

	const playerData = window?.itdAudioPlayers[`episode-${playerEpisodeID}`];

	// Show duration.
	const showDuration = () => {
		externalControl.querySelector(selectors.externalControlDuration).textContent = `${toMinutes(playerData.audioEl.duration)} min`;
	};
	if (playerData.audioEl.readyState > 0) {
		showDuration();
	} else {
		playerData.audioEl.addEventListener('loadedmetadata', showDuration);
	}

	// Handle click events on play buttons
	const playButtons = externalControl.querySelectorAll(selectors.externalControlPlayBtn);
	playButtons.forEach((playBtn) => {
		playBtn.addEventListener('click', () => {
			if (externalControl.getAttribute('data-play-state') === 'play') {
				closePlayer();
				return;
			}

			/**
			 * 1. Reset other players
			 */

			// Reset external control play state.
			document.querySelectorAll(selectors.externalControl).forEach((control) => {
				control.setAttribute('data-play-state', 'pause');
			});

			// Hide players.
			const stickyPlayers = document.querySelectorAll(selectors.stickyPlayer);
			stickyPlayers.forEach((player) => player.classList.remove(classNames.showStickyPlayer));

			// Pause.
			if (window?.itdAudioPlayers) {
				Object.values(window.itdAudioPlayers).forEach((player) => player.stop());
			}

			/**
			 * 2. Start clicked player
			 */

			if (playerData) {
				// Update external control state.
				externalControl.setAttribute('data-play-state', 'play');

				// Show player.
				stickyPlayer.classList.add(classNames.showStickyPlayer);

				// Play.
				playerData.play();
			}
		});
	});

	const closePlayer = () => {
		stickyPlayer.classList.remove(classNames.showStickyPlayer);
		externalControl.setAttribute('data-play-state', 'pause');
		window.itdAudioPlayers[`episode-${playerEpisodeID}`].stop();
	};

	// Handle click events on close button
	const playerCloseBtn = stickyPlayer.querySelector(selectors.externalControlCloseBtn);
	playerCloseBtn?.addEventListener('click', closePlayer);
};
